import wixData from 'wix-data';
import wixUsers from 'wix-users';
import wixLocationFrontend from 'wix-location-frontend';
import wixLocation from 'wix-location';

const query = wixLocation.query;

export function setRecommendedQuiz() {
    console.log("woww inside setRecommendedQuiz func")

    if (wixUsers.currentUser.loggedIn) {
        wixUsers.currentUser.getEmail().then((email) => {

            wixData.query("lastQuizTaken")
                .eq("title", email)
                .find()
                .then((results) => {
                    //console.log("woww results", results.items);

                    
                    if (results.items.length > 0 && results.items[0].recommendationScores !== undefined) {
                        const resultsArr = results.items[0];
                        const recommendedScores = resultsArr.recommendationScores;
                        const sortedRecommendedQuizObj = Object.entries(recommendedScores).sort((a, b) => b[1] - a[1]);
                        const completedQuizArr = [];
                        const allKeysArr = Object.keys(resultsArr);
                        let recQuizNotTaken = null;
                        const sortedQuizArr = [];

                        allKeysArr.forEach((key) => {
                            if (key.includes("results") || key.includes("Results")) {
                                completedQuizArr.push(key);
                            }
                        })

                        sortedRecommendedQuizObj.forEach((quizArr) => {
                            sortedQuizArr.push(quizArr[0]);
                        })

                        recQuizNotTaken = sortedQuizArr.filter(quiz => !completedQuizArr.includes(quiz));

                        if (recQuizNotTaken.length > 0) {
                            $w("#recQuizBox").expand();
                        } else {
                            setNextRecommendedQuiz("false", completedQuizArr);
                            return;
                        }

                        // console.log("wow recommendedScores", recommendedScores);
                        // console.log("wow sortedQuizArr", sortedQuizArr);
                        // console.log("wow resultsArr", resultsArr);
                        // console.log("wow completedQuizArr", completedQuizArr);
                        // console.log("wow recQuizNotTaken", recQuizNotTaken);

                        const recQuiz = recQuizNotTaken[0];
                        // const recQuiz = "resultsEmotionalIntelligence";
                        console.log(" rec quz ", recQuiz);

                        wixData.query("assessments")
                            .eq("database", recQuiz)
                            .find()
                            .then((result) => {
                                const recQuizArr = result.items[0];
                                console.log("wow recQuizArr", recQuizArr);
                                setData(recQuizArr);
                                /*$w("#recQuizImg").src = recQuizArr.listImage;
                                $w("#recQuizHeading").text = recQuizArr.title;
                                $w("#recQuizDesc").text = recQuizArr.shortDescription;
                                $w("#recQuizDesc").text = `${recQuizArr.shortDescription.slice(0,140)}...`;

                                if (query.minimal == "yes") {
                                    $w("#recQuizOpen1").link = `${recQuizArr.quizUrl}&webViewTo=assessment-page`;
                                    $w("#recQuizOpen2").link = `${recQuizArr.quizUrl}&webViewTo=assessment-page`;
                                    $w("#recQuizReadMore").html = `<p class="font_7 wixui-rich-text__text"><a href="${recQuizArr.quizIntro}&webViewTo=landing-page">Read More</a></p>`;
                                } else {
                                    $w("#recQuizOpen1").link = recQuizArr.quizUrlWebsite;
                                    $w("#recQuizOpen2").link = recQuizArr.quizUrlWebsite;
                                    $w("#recQuizReadMore").html = `<p class="font_7 wixui-rich-text__text"><a href="${recQuizArr.landingPageDefault}" target="_blank">Read More</a></p>`;
                                }*/

                                updateOnPrintable(recQuizArr);
                            })
                            .catch((err) => {
                                //    
                            })
                    } else if (results.items.length > 0 && !results.items[0].recommendationScores) {
                        const allResultsArr = results.items;
                        let allKeysArr = [];
                        const completedQuizArr = [];

                        allResultsArr.forEach((result) => {
                            allKeysArr = Object.keys(result);
                        })

                        allKeysArr.forEach((key) => {
                            if (key.includes("results") || key.includes("Results")) {
                                completedQuizArr.push(key);
                            }
                        })

                        setNextRecommendedQuiz("false", completedQuizArr);
                    } else {
                        // console.log("wow no results")
                        wixData.query("assessments")
                            .ascending("recomendationOrder")
                            .eq("active", 1)
                            .find()
                            .then((result) => {
                                const recQuizArr = result.items[0];
                                setData(recQuizArr);
                            })
                            .catch((err) => {
                                console.error(err)
                            })

                    }
                })
        })
    } else {
        setNextRecommendedQuiz("not_logged_in");
    }
}

function showRecomandedQuizRepeater(quizArray) {
    $w("#recQuizBox").collapse();
    $w("#quizRecommendedRepeaterBox").expand()
    $w("#quizRecommendedRepeater").data = quizArray.slice(0, 3);
    setTimeout(() => {
        $w("#quizRecommendedRepeater").forEachItem(($item, itemData, index) => {
            console.log(itemData.title);
            $item("#recQuizImg1").src = itemData.listImage;
            $item("#recQuizHeading1").text = itemData.title;
            $item("#recQuizDesc1").text = itemData.shortDescription;
            $item("#recQuizDesc1").text = `${itemData.shortDescription.slice(0,140)}...`;
            $item("#recQuizOpen2, #recQuizOpen1").link = `${itemData.quizUrlWebsite}`;
            console.log('URL',`${itemData.quizUrlWebsite}`);
            $item("#recQuizReadMore1").html = `<p class="font_7 wixui-rich-text__text"><a href="${itemData.landingPageDefault}" target="_blank">Read More</a></p>`;
        })
    }, 1000)
}

function setNextRecommendedQuiz(isRecommendedScoresGenerated, completedQuizArr) {
    const currentQuiz = wixLocationFrontend.prefix;
    // console.log("wow else ran", isRecommendedScoresGenerated)

    wixData.query("assessments")
        .ascending("recomendationOrder")
        .eq("active", 1)
        .find()
        .then((result) => {

            if (!wixUsers.currentUser.loggedIn) {
                //$w("#quizRecommendedRepeaterBox").length returns undefined if its available on the page, otherwise its returns 0
                if ($w("#quizRecommendedRepeaterBox").length == undefined) {
                    showRecomandedQuizRepeater(result.items)
                    return
                }
            }

            const allQuizArr = result.items;
            let currentQuizIndex = 0;
            let recQuizArr = {};

            // console.log("wow allQuizArr", allQuizArr);

            if (isRecommendedScoresGenerated === "false") {
                const difference = [...getDifference(allQuizArr, completedQuizArr)];
                // console.log("wow zz difference", difference[0]);
                // console.log("wow zz allQuizArr", allQuizArr);
                // console.log("wow zz completedQuizArr", completedQuizArr);
                recQuizArr = difference[0];
            } else {
                if (currentQuiz !== "life-satisfaction-results") {
                    recQuizArr = allQuizArr[0];
                } else {
                    allQuizArr.forEach((quiz) => {
                        if (quiz.reportingPath == currentQuiz) {
                            currentQuizIndex = allQuizArr.indexOf(quiz);
                        }
                    })

                    recQuizArr = allQuizArr[currentQuizIndex + 1];
                }
            }

            // $w("#recQuizBox").expand();

            if (!recQuizArr) {
                $w("#recQuizBox").collapse();
                return;
            } else {
                $w("#recQuizBox").expand();
            }

            // console.log("wow currentQuizIndex", currentQuizIndex)
            // console.log("wow recQuiz", recQuizArr)
            setData(recQuizArr);
            /*$w("#recQuizImg").src = recQuizArr.listImage;
            $w("#recQuizHeading").text = recQuizArr.title;
            $w("#recQuizDesc").text = recQuizArr.shortDescription;
            $w("#recQuizDesc").text = `${recQuizArr.shortDescription.slice(0,140)}...`;

            if (query.minimal == "yes") {
                $w("#recQuizOpen1").link = `${recQuizArr.quizUrl}&webViewTo=assessment-page`;
                $w("#recQuizOpen2").link = `${recQuizArr.quizUrl}&webViewTo=assessment-page`;
                $w("#recQuizReadMore").html = `<p class="font_7 wixui-rich-text__text"><a href="${recQuizArr.quizIntro}&webViewTo=landing-page">Read More</a></p>`;
            } else {
                $w("#recQuizOpen1").link = recQuizArr.quizUrlWebsite;
                $w("#recQuizOpen2").link = recQuizArr.quizUrlWebsite;
                $w("#recQuizReadMore").html = `<p class="font_7 wixui-rich-text__text"><a href="${recQuizArr.landingPageDefault}" target="_blank">Read More</a></p>`;
            }*/

            updateOnPrintable(recQuizArr);
        })
        .catch((err) => {
            console.error(err)
        })
}

function getDifference(array1, array2) {
    return array1.filter(
        object1 => !array2.some(
            object2 => object1.database === object2
        ),
    );
}

function updateOnPrintable(quizToShow) {
    if ($w("#htmlPrint")) {
        console.log("wow HAS htmlPrint", quizToShow)
        console.log("wow htmlPrint data", $w("#htmlPrint"))
        // $w("#htmlPrint").postMessage(result);
    } else {
        console.log("wow NO htmlPrint")
    }
}

function setData(recQuizArr) {
    $w("#recQuizImg").src = recQuizArr.listImage;
    $w("#recQuizHeading").text = recQuizArr.title;
    $w("#recQuizDesc").text = recQuizArr.shortDescription;
    $w("#recQuizDesc").text = `${recQuizArr.shortDescription.slice(0,140)}...`;

    if (query.minimal == "yes") {
        $w("#recQuizOpen1").link = `${recQuizArr.quizUrl}&webViewTo=assessment-page`;
        $w("#recQuizOpen2").link = `${recQuizArr.quizUrl}&webViewTo=assessment-page`;
        $w("#recQuizReadMore").html = `<p class="font_7 wixui-rich-text__text"><a href="${recQuizArr.quizIntro}&webViewTo=landing-page">Read More</a></p>`;
    } else {
        $w("#recQuizOpen1").link = recQuizArr.quizUrlWebsite;
        $w("#recQuizOpen2").link = recQuizArr.quizUrlWebsite;
        console.log('url', $w("#recQuizOpen1").link)
        $w("#recQuizReadMore").html = `<p class="font_7 wixui-rich-text__text"><a href="${recQuizArr.landingPageDefault}" target="_blank">Read More</a></p>`;
    }
}